















































































import Issue from "@/models/util/issue";
import { Mutations } from "@/store/mutations";
import Vue from "vue";
import StuntSheet from "../../models/StuntSheet";
import StuntSheetModal from "./StuntSheetModal.vue";

export default Vue.extend({
  name: "MenuLeft",
  components: {
    StuntSheetModal,
  },
  data() {
    return {
      stuntSheetModalActive: false,
    };
  },
  computed: {
    beat: {
      get(): number {
        return this.$store.getters.getBeat;
      },
      set(beat: number): void {
        this.$store.commit(Mutations.SET_BEAT, beat);
      },
    },
    beatString(): string {
      return this.$store.getters.getBeat === 0
        ? "Hup!"
        : this.$store.getters.getBeat.toString();
    },
    stuntSheets(): StuntSheet[] {
      return this.$store.state.show.stuntSheets;
    },
    selectedSS: {
      get(): number {
        return this.$store.getters.getSelectedStuntIndex;
      },
      set(selectedSS: number): void {
        this.$store.commit(Mutations.SET_SELECTED_SS, selectedSS);
        this.$store.commit(Mutations.SET_BEAT, 0);
      },
    },
    selectedSSBeats(): number {
      const selectedSS = this.$store.getters
        .getSelectedStuntSheet as StuntSheet;
      return selectedSS.beats;
    },
    title(): string {
      return this.$store.state.show.title;
    },
  },
  methods: {
    isIssue(index: number): boolean {
      return (
        this.$store.state.show.stuntSheets[index].issues.length !== 0 ||
        this.$store.state.show.issues.some((issue: Issue) => {
          return issue.stuntSheets.some((ss: number) => {
            return ss === index;
          });
        })
      );
    },
    addStuntSheet(): void {
      this.$store.commit(Mutations.ADD_STUNT_SHEET);
    },
    incrementBeat(): void {
      this.$store.commit(Mutations.INCREMENT_BEAT);
    },
    decrementBeat(): void {
      this.$store.commit(Mutations.DECREMENT_BEAT);
    },
  },
});
